/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiInvoiceSnapshot } from '@Model';
import type { HttpActions, ListInfo, ListRequest, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of InvoiceSnapshotsController.
 */
export class InvoiceSnapshotsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /invoice_snapshots:query
     */
    public getListGet(pageNo: number, pageSize: number): Promise<Result<ListInfo<ApiInvoiceSnapshot>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);

        return this.http.get<Result<ListInfo<ApiInvoiceSnapshot>>>('/invoice_snapshots:query', query);
    }

    /**
     * Calls POST /invoice_snapshots:query
     */
    public getListPost(listRequest: ListRequest): Promise<Result<ListInfo<ApiInvoiceSnapshot>>> {
        return this.http.post<Result<ListInfo<ApiInvoiceSnapshot>>, ListRequest>('/invoice_snapshots:query', listRequest);
    }

    /**
     * Calls GET /invoice_snapshots/{invoiceSnapshotId}
     */
    public get(invoiceSnapshotId: string): Promise<Result<ApiInvoiceSnapshot>> {
        return this.http.get<Result<ApiInvoiceSnapshot>>(`/invoice_snapshots/${invoiceSnapshotId}`);
    }
}
